import React from 'react';

import { FormControlLabel, Switch } from '@mui/material';

import ContentCard from '../../../../components/ContentCard';
import { useUpdateClassMutation } from '../../../../services/classes';
import { Class } from '../../../../services/classes/types';
import useError from '../../../../utils/react/hooks/useError';
import useSuccess from '../../../../utils/react/hooks/useSuccess';

interface NotificationsCardProps {
  classObj: Class;
}

const NotificationsCard = ({ classObj }: NotificationsCardProps) => {
  const [updateClass, { isError: isUpdateClassError,
    error: updateClassError,
    isSuccess: isUpdateClassSuccess }] = useUpdateClassMutation();

  useError(isUpdateClassError, updateClassError);
  useSuccess(isUpdateClassSuccess, 'Class notifications updated');

  return (
    <ContentCard
      title="Notifications"
      variant="outlined"
    >
      <FormControlLabel
        control={(
          <Switch
            checked={classObj.remindBreaks}
            onChange={(event) => updateClass({
              subject: classObj.subject,
              classId: classObj.classId,
              newAttributes: {
                remindBreaks: event.target.checked,
              },
            })}
          />
        )}
        label="Notify Breaks"
      />
    </ContentCard>
  );
};
export default NotificationsCard;
